// extracted by mini-css-extract-plugin
export default {"category":"select-view_category__lIplQ"};